import React, { useState } from 'react';
import './index.scss';
import { TabPanel, Tabs } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
export default function TabPanelContext(props: any) {
  let { tabList, language } = props;
  return tabList?.map((e: any, i: any) => {
    return (
      <div className="strengthstab-card-wrap" key={i}>
        <SvgIcon
          type={
            parseFloat(e.sentiment_rating) > 3.5
              ? 'happy-icon'
              : parseFloat(e.sentiment_rating) > 2.5
              ? 'expressionless-icon'
              : 'unhappy-icon'
          }
          className="table-flex-icon"
        ></SvgIcon>
        <span className="table-flex-text">{e.content[language]}</span>
      </div>
    );
  });
}
